import React, { useState } from 'react';

import { CaptchaSubscribeManager } from '@entities/captcha/ui/CaptchaSubscribeManager';

import { ButtonContainer } from '../../../Button/Button';
import { Input } from '../../../Input/Input';
import { isValidPhoneNumberFormat, validatePhone, MIN_PHONE_LENGTH } from '../../../validate';
import { FormTitle } from '../../FormTitle/FormTitle';
import { Form } from '../Form';
import cls from '../Step.module.css';

export const StepTwo = ({ state, updatePhone, sendPhoneForSendOneTimeCode, token, setToken }) => {
    const [errors, setErrors] = useState({
        phone: null,
    });

    const isButtonDisabled =
        !!Object.values(errors).filter((item) => !!item).length ||
        state.phoneNumber.length <= MIN_PHONE_LENGTH ||
        !token;

    const saveError = (e) => {
        const error = validatePhone(e);
        if (error) {
            setErrors((prevState) => ({
                ...prevState,
                phone: error,
            }));
        } else {
            setErrors((prevState) => ({ ...prevState, phone: null }));
        }
    };

    return (
        <div>
            <FormTitle
                title={i18next.t('StepTwo.return.FormTitle.title')}
                subtitle={i18next.t('StepTwo.return.FormTitle.subtitle')}
            />

            <Form>
                <Input
                    label={i18next.t('StepTwo.return.Input.label')}
                    type="phone"
                    error={!!errors.phone}
                    helperText={errors.phone ?? ' '}
                    value={state.phoneNumber}
                    onChange={(e) => {
                        setErrors((prevState) => ({ ...prevState, phone: null }));
                        if (isValidPhoneNumberFormat(e)) {
                            updatePhone(e.target.value);
                        }
                    }}
                    onBlur={saveError}
                    inputProps={{
                        'data-id': 'register-phone',
                    }}
                />
                <div className={cls.capchaWrapper}>
                    <CaptchaSubscribeManager handleToken={setToken} />
                </div>
                <ButtonContainer
                    textButton={i18next.t('StepTwo.return.ButtonContainer.textButton')}
                    disable={isButtonDisabled}
                    onClick={sendPhoneForSendOneTimeCode}
                    needShowLoader={state.needShowLoader}
                />
            </Form>
        </div>
    );
};
